import { takeLatest } from 'redux-saga/effects';
import {
  getModuleListSuccess, getModuleListFail,
  getModuleDetailsSuccess, getModuleDetailsFail
} from './moduleState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/system/modules');
const redirectData = {route:'/console/modules', mode: 'list', recordId:0 };
const modelName = 'Module';
const modelId = 'mol_id';

function* getModuleList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getModuleListSuccess, 
		getModuleListFail, null, null, LOADING_MSG);
}

function* getModuleDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getModuleDetailsSuccess, 
		getModuleDetailsFail, null, null, LOADING_MSG);		
}

function* doModuleCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getModuleDetailsSuccess, 
		getModuleDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doModuleUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getModuleDetailsSuccess, 
		getModuleDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doModuleDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getModuleDetailsSuccess, 
		getModuleDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* moduleSaga() {
  yield takeLatest('module/getModuleList', getModuleList);
  yield takeLatest('module/getModuleDetails', getModuleDetails);
  yield takeLatest('module/doModuleCreate', doModuleCreate);
  yield takeLatest('module/doModuleUpdate', doModuleUpdate);
  yield takeLatest('module/doModuleDelete', doModuleDelete);  
}

export default moduleSaga;
